// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1vtVC","footer":"styles_footer__1V-Or"};